<div class="modal fade">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Congelar Cliente
                </h4>     
                <h6 class="modal-subtitle" *ngIf="canEditCliente">
                    Selecione o cliente e informe o motivo e justificativa do seu congelamento
                </h6>                    
                <h6 class="modal-subtitle" *ngIf="!canEditCliente">
                    Informe o motivo e justificativa do congelamento deste cliente
                </h6>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entity"> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label" for="clienteCongelar">Cliente</label>
                                <ng-template [ngIf]="canEditCliente">
                                    <sgt-typeahead-cliente [(ngModel)]="entity.cliente" name="clienteCongelar" id="clienteCongelar"
                                        #typeaeadCliente #clienteCongelar="ngModel" [ngControl]="clienteCongelar" required="required"
                                        (entitySelected)="onSelectCliente($event)" (clearEntity)="onClearCliente()">
                                    </sgt-typeahead-cliente>
                                    <sgt-form-control-error
                                        *ngIf="clienteCongelar.errors && clienteCongelar.errors.required && clienteCongelar.dirty"
                                        msgError="O cliente é obrigatório">
                                    </sgt-form-control-error>                                                                   
                                </ng-template>

                                <ng-template [ngIf]="!canEditCliente">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text">{{entity?.cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                        </div>
                                        <input type="text" class="form-control" [value]="entity?.cliente?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text text-muted" *ngIf="entity?.cliente">
                                        {{entity?.cliente?.pessoa?.nomeFantasia}} - {{entity?.cliente?.pessoa?.cnpjCpf}} - {{entity?.cliente?.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{entity?.cliente?.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                                    </p>
                                </ng-template>                                
                            </div>
                        </div>
                        <div class="row" *ngIf="!isRepresentante">
                            <div class="form-group form-group-representante col-12">
                                <label class="col-form-label">Representante</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entity?.representante?.pessoa?.codigoIntegracaoErp}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entity?.representante?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                </div>
                                <p class="form-text text-muted" *ngIf="entity?.representante">
                                    {{entity?.representante?.pessoa?.nomeFantasia}} - {{entity?.representante?.pessoa?.cnpjCpf}}
                                </p>                                                                
                            </div>
                        </div>   

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="motivoCongelamento" class="col-form-label">Motivo</label>
                                <sgt-motivo-perda-venda-select
                                    #motivoCongelamentoSelect
                                    #motivoCongelamento="ngModel"
                                    [(ngModel)]="entity.idMotivoCongelamento"
                                    name="motivoCongelamento"
                                    id="motivoCongelamento"
                                    required="required"
                                    [canSelectNull]="true"
                                    [somenteAtivos]="true"
                                    [clienteCongelado]="true">
                                </sgt-motivo-perda-venda-select>
                                <p class="form-text text-muted">Informe o motivo pelo qual este cliente deve ser congelado</p>
                                <sgt-form-control-error
                                    *ngIf="motivoCongelamento.errors && motivoCongelamento.errors.required && motivoCongelamento.dirty"
                                    msgError="O motivo do congelamento é obrigatório">
                                </sgt-form-control-error>                                
                            </div>
                        </div>                        

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="justificativaCongelamento" class="col-form-label">Justificativa</label>
                                <textarea class="form-control" [(ngModel)]="entity.justificativaCongelamento" name="justificativaCongelamento" id="justificativaCongelamento" 
                                    #justificativaCongelamento="ngModel" rows="10" required="required" minlength="15">
                                </textarea>
                                <p class="form-text text-muted">Justifique o congelamento deste cliente</p>
                                <sgt-form-control-error
                                    *ngIf="justificativaCongelamento.errors && justificativaCongelamento.errors.required && justificativaCongelamento.dirty"
                                    msgError="A justificativa é obrigatória">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="justificativaCongelamento.errors && justificativaCongelamento.errors.minlength"
                                    msgError="A justificativa deve ter no mínimo 15 caracteres">
                                </sgt-form-control-error>                                                                                               
                            </div>
                        </div>
                    </div>
                </form>                
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancel()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
                <button type="button" class="btn btn-congelar-cliente" id="btnClienteCongelarModal" [disabled]="!form.valid" (click)="congelar()">
                    <i class="fas fa-snowflake"></i> Congelar
                </button>                
            </div>            
        </div>
    </div>
</div>